export default __webpack_public_path__ + "static/media/sevens-white.de9db457.svg";